module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/seats-icon-36381b7ca137c07b97bbbc5230db27ce.png";